export default {
  Search: {
    SearchPlaceHolder: 'Tìm kiếm',
    AddButton: 'Thêm mới',
    AddButtonShortKey: 'Thêm mới (F9)',
    SubmitButton: 'Chọn',
    SubmitButtonShortKey: 'Chọn (Ctrl + S)',
    CancelButton: 'Hủy',
  },

  Validate: {
    DuplicateName: '{0} đã bị trùng trong danh sách nhập. Vui lòng kiểm tra lại.',
    Arise: '{0} tổng hợp đã phát sinh dữ liệu. Do vậy, để thêm mới được <span class="color-green">{1}</span> , hệ thống phải chuyển toàn bộ dữ liệu gắn với {0} <span class="color-green">{2}</span> sang cho {0} <span class="color-green">{1}</span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    Duplicate: '{0} &lt;{1}&gt; đã tồn tại trong hệ thống. Xin vui lòng kiểm tra lại.',
    EditVersion: 'Dữ liệu đã bị thay đổi bởi người dùng khác. Xin vui lòng nạp lại.',
    DeleteMultiHasMultiArisened: 'Có một số bản ghi xuất hiện lỗi trong quá trình xóa.', // Chi tiết xem phía dưới: "[ {0} ]
    DeleteMultiHasMultiArisened2: 'Có một số bản ghi đã có phát sinh. Không thể xóa!',
    ConfirmDeleteMultiHasMultiArisened: 'Có một số bản ghi đã có phát sinh. Bạn có muốn tiếp tục xóa không!',
    DeleteMultiHasOneArisened: 'Có một bản ghi đã có phát sinh. Không thể xóa!', // <{0}>
    DeleteMultiHasOneArisenedComponentAsset: 'Linh kiện đã có phát sinh, bạn không thể xóa!', // <{0}>
    NotPermission: 'Bạn không có quyền thực hiện chức năng này. Vui lòng kiểm tra lại!',
    ManagerUnitHasArise: 'Đơn vị quản lý đã có phát sinh dữ liệu, bạn không thể bỏ check là đơn vị quản lý.',
    ParentUnitHasArise: 'Đơn vị quản lý cấp cha của đơn vị này đã có phát sinh dữ liệu đã, bạn không thể đặt là đơn vị quản lý.',
    ManagerUnitHasDependent: 'Đơn vị đã có phát sinh đơn vị con là đơn vị quản lý, bạn không thể bỏ check là đơn vị quản lý.',
    NewMessageDelete: '{0} <{1}> đã có phát sinh. Bạn có muốn tiếp tục xóa không?',
    Required: 'Nhập thiếu thông tin {0}',
  },

  Detail: {
    SubmitError: 'Đã có lỗi xảy ra, vui lòng liên hệ với MISA để được hỗ trợ.',
    AddDetail: 'Thêm dòng',
    SaveSuccessMessage: 'Cất dữ liệu thành công',
  },

  Message: {
    ConfirmDeleteTitle: 'Xóa {0}',
    ConfirmDeleteVoucherTitle: 'Xóa chứng từ',
    ConfirmDeleteVoucher: 'Bạn có muốn xóa chứng từ <span class="color-green">{0}</span> không?',
    ConfirmDelete: 'Bạn có muốn xóa {0} <span class="color-green">{1}</span> không?',
    ConfirmDeleteDefault: 'Bạn có muốn xóa {0} {1} không?',
    ConfirmDeleteMuti: 'Bạn có chắc chắn muốn xóa các bản ghi {0} được chọn không?',
    ConfirmSaveChangeClose: 'Bạn có muốn Cất không?',
    NotSelected: 'Vui lòng chọn <span class="color-green">ít nhất 1 bản ghi</span> để thực hiện được chức năng này.',
    Exception: 'Đã có lỗi xảy ra, vui lòng liên hệ với MISA để được hỗ trợ',
    DeleteSuccess: 'Xóa thành công',
    WarningTitle: 'Cảnh báo',
    SaveSuccess: 'Lưu thành công',
    InsertSuccess: 'Thêm thành công',
    UpdateSuccess: 'Sửa thành công',
    Developing: 'Chức năng đang được phát triển',
    DeleteWarningTitle: 'Không thể xóa',
    WarningBatchExcution: 'Không hợp lệ',
    ValidateInvalidTitle: 'Không hợp lệ',
    FailSave: 'Cất không thành công',
    ValidateBusinessTitle: 'Chứng từ không hợp lệ',
    ValidateBusiness: 'Vui lòng nhập ít nhất một dòng chứng từ chi tiết',
    ErrorSystemDeleteMulti: '{0} đã chọn là dữ liệu thuộc hệ thống',
    ConfirmErrorSystemDelete: '{0} <span class="color-green">{1}</span> đã chọn là dữ liệu thuộc hệ thống',
    ConfirmErrorDeleteTitle: 'Không thể xóa',
    WarningIncurredDataTitle: 'Xóa không thành công',
    WarningIncurredDataContent: '{0} <span class="color-green">{1}</span> đã có phát sinh dữ liệu. Bạn phải xóa các phát sinh liên quan trước khi xóa <span class="color-green">{2}</span>',
    DeleteRelation: 'Chứng từ số <span class="color-green">{0}</span> có liên quan đến chứng từ số <span class="color-green">{1}</span>. Bạn có muốn xóa chứng từ liên quan này không?',
    DeleteRelationTitle: 'Xóa chứng từ',
    DeleteRelationMulti: 'Chứng từ số <span class="color-green">{0}</span> có liên quan đến chứng từ số <span class="color-green">{1}</span>. </br>',
    ConfirmDeleteRelation: 'Bạn có muốn xóa chứng từ liên quan này không?',
    GetDefaultSettingLayoutSuccess: 'Lấy tùy chỉnh giao diện mặc định thành công',

    ConfirmUnactiveMuti: 'Bạn có chắc chắn muốn ngừng sử dụng {0} <span class="color-green">{1} và {2} {0} khác</span> không?',
    ConfirmActiveMuti: 'Bạn có chắc chắn muốn sử dụng {0} <span class="color-green">{1} và {2} {0} khác</span> không?',
    ConfirmUnactive: 'Bạn có chắc chắn muốn ngừng sử dụng {0} <span class="color-green">{1}</span> không?',
    ConfirmActive: 'Bạn có chắc chắn muốn sử dụng {0} <span class="color-green">{1}</span> không?',
    ConfirmUnactiveTitle: 'Ngừng sử dụng {0}',
    ConfirmActiveTitle: 'Sử dụng {0}',
    ImportSuccess: 'Nhập khẩu thành công',
    ConfirmCancelTitle: 'Hủy xếp lớp',
    ConfirmCancelMuti: 'Các thông tin học tập đã phát sinh sẽ bị mất khi hủy xếp lớp. Bạn có chắc chắn muốn hủy xếp lớp cho học sinh <span class="color-green">{0} và {1} học sinh khác</span> không?',
    ConfirmCancel: 'Các thông tin học tập đã phát sinh sẽ bị mất khi hủy xếp lớp. Bạn có chắc chắn muốn hủy xếp lớp cho học sinh <span class="color-green">{0}</span> không?',
    CancelSuccess: 'Hủy xếp lớp thành công!',
    ArrangeSuccess: 'Thực hiện xếp lớp thành công cho học sinh!',
    NoEmtyData: 'Không có học sinh lưu ban năm trước',
    SchoolLevelNotPlaySchool: 'Chức năng chỉ dành cho cấp tiểu học trở lên',
    ConfirmCreate: 'Xác nhận tạo {0} thứ {1} - Năm học {2}?<br>Thầy cô vui lòng thiết lập mới các thông tin:<br>- Chỉ tiêu tuyển sinh<br>- Khu vực tuyển sinh<br>- Thời gian nhận hồ sơ ',
    InfoTitle: 'Thông báo',
  },

  MessageDeleteParentNode: {
    DeleteWarningParentTitle: 'Xóa không thành công',
    DeleteWarningParentContent: 'Không thể xóa danh mục cha nếu chưa xóa danh mục con.',
  },
}
